module.exports = __webpack_public_path__ + "img/ful_chat_room.6ef54492.png";